import styled from 'styled-components';
export const Container = styled.div`
  background: white;
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 14px;
  padding: 0 30px;
`;
